import { Component } from '@angular/core';
import {
	AlertController,
	IonicPage,
	Loading,
	LoadingController,
	NavController,
	NavParams,
	ToastController,
	ModalController,
} from 'ionic-angular';
//import { DatePicker } from '@ionic-native/date-picker'; NON FUNZIONA SU BROWSER

import { CalendarModal, CalendarModalOptions, CalendarResult } from "ion2-calendar";

//import {LoginPage}from '../../pages/login/login';

import { AuthProvider } from '../../providers/auth/auth';
import { MessageProvider } from '../../providers/message/message';
//import { CondominiumProvider } from '../../providers/condominium/condominium';

import { Condominium, Message, DeviceType, MessageVisibility, HousingUnit, User, MessagePriority } from '../../models/models';
import { DeviceProvider } from '../../providers/device/device';


import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeIt);

@IonicPage()
@Component({
	selector: 'page-message-create',
	templateUrl: 'message-create.html',
})
export class MessageCreatePage {
	public priority: MessagePriority;
	public forwarding: Message;
	public housingUnit: HousingUnit = null;
	public user: User = null;
	public condominium: Condominium = null;
	/**
	Messaggio a cui rispondere
	*/
	public message: Message = null;
	public loading: Loading;
	public isLoading = true;

	public isHighlighted: boolean = false;
	public subject: string = '';
	public body: string = '';
	public visibility: MessageVisibility = MessageVisibility.PRIVATE;
	public pin_until: Date = null;


	constructor(
		private alertCtrl: AlertController,
		private auth: AuthProvider,
		//private condominiums:CondominiumProvider,
		//private datePicker: DatePicker,
		private devices: DeviceProvider,
		private loadingCtrl: LoadingController,
		public modalCtrl: ModalController,
		private messages: MessageProvider,
		private navCtrl: NavController,
		private navParams: NavParams,
		private toastCtrl: ToastController
	) {
		this.condominium = <Condominium>navParams.get('condominium');
		//TODO
		this.housingUnit = <HousingUnit>navParams.get('housingUnit');
		this.user = <User>navParams.get('user');
		//messaggio a cui rispondere
		this.message = <Message>navParams.get('message');
		this.subject = navParams.get('subject');
		if (!this.subject) this.subject = '';
		this.body = navParams.get('body');
		if (!this.body) this.body = '';
		this.visibility = navParams.get('visibility');
		if (!this.visibility) this.visibility = MessageVisibility.PRIVATE;
	}

	ionViewWillEnter() {
		this.isLoading = false;
	}

	ionViewWillUnload() {
		switch (this.devices.actualType) {		//se il contesto lo richiede esegue il logout in uscita
			case DeviceType.DASHBOARD:
			case DeviceType.INTERCOM:
				if (this.auth.user) {
					this.auth.logout();
				}
				break;
		}
	}


	public isHighlightedToggled(event) {
		this.priority = event.checked ? MessagePriority.HIGH : MessagePriority.NORMAL;
		console.log('Priorità del messaggio:', this.priority);
	}

	public showDatePicker() {
		let self = this;
		const options: CalendarModalOptions = {
			title: 'Tieni in cima fino a questa data:',
			monthFormat: 'MM/YYYY',
			weekdays: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
			weekStart: 1,
			defaultDate: new Date(),
			closeLabel: 'Annulla',
			doneLabel: 'Imposta',
			closeIcon: true,
			doneIcon: true
		};

		let calendarModal = this.modalCtrl.create(CalendarModal, {
			options: options
		});

		calendarModal.present();

		calendarModal.onDidDismiss((dateResult: CalendarResult, type: string) => {
			if (type == 'done') {
				console.log('Data selezionata:', dateResult);
				self.pin_until = dateResult.dateObj;
			}
		})
		/*
		this.datePicker.show({
		date: new Date(),
		mode: 'date',
		androidTheme: this.datePicker.ANDROID_THEMES.THEME_HOLO_DARK
	}).then(
	date => console.log('Got date: ', date),
	err => console.log('Error occurred while getting date: ', err)
);
*/
	}

	/**
	Invia il messaggio
	*/
	public send() {
		let self = this;
		this.loading = this.loadingCtrl.create({
			content: 'Invio in corso...',
			dismissOnPageChange: false
		});
		this.loading.present();

		if (this.condominium) {
			//Messaggio per il condominio
			this.messages.sendToCondominium(
				this.condominium,
				this.body,
				this.subject,
				this.visibility,
				this.priority,
				this.pin_until,
				this.message
			).then((message: Message) => {
				self.loading.dismiss();
				if (message) {
					let toast = this.toastCtrl.create({
						message: "Messaggio inviato al condominio",
						position: 'middle',
						duration: 3000
					});
					toast.present();
					self.navCtrl.pop();
				} else {
					let errorAlert = self.alertCtrl.create({
						title: 'Errore',
						subTitle: "Impossibile inivare il messaggio in questo momento",
						buttons: ['OK']
					});
					errorAlert.present();
				}
			}, error => {
				self.loading.dismiss();
				let errorAlert = self.alertCtrl.create({
					title: 'Errore',
					subTitle: error,
					buttons: ['OK']
				});
				errorAlert.present();
			});
		} else if (this.user) {
			//Messaggio per l'utente
			this.messages.sendToUser(
				this.user,
				this.body,
				this.subject,
				null,
				null,
				this.message
			).then((message: Message) => {
				self.loading.dismiss();
				if (message) {
					let toast = this.toastCtrl.create({
						message: "Messaggio inviato all'utente",
						position: 'middle',
						duration: 3000
					});
					toast.present();
					self.navCtrl.pop();
				} else {
					let errorAlert = self.alertCtrl.create({
						title: 'Errore',
						subTitle: "Impossibile inivare il messaggio in questo momento",
						buttons: ['OK']
					});
					errorAlert.present();
				}
			}, error => {
				self.loading.dismiss();
				let errorAlert = self.alertCtrl.create({
					title: 'Errore',
					subTitle: error,
					buttons: ['OK']
				});
				errorAlert.present();
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/pages/message-create/message-create.ts